import { useMemo } from "react";

import { buildTalkToSalesUrl } from "utils/talkToSales";
import { useMyProfile } from "./profile";

/**
 * Returns the Talk-to-Sales (Calendly) URL pre-filled with the current user's
 * name, email, and team id. Returns an empty string until `useMyProfile`
 * resolves — callers should disable the CTA when the URL is empty.
 */
export const useTalkToSalesUrl = (): string => {
  const { data: myProfile } = useMyProfile();
  return useMemo(() => buildTalkToSalesUrl(myProfile), [myProfile]);
};
